export default "__VITE_ASSET__DZRf4p8y__"